// extracted by mini-css-extract-plugin
export default {"gridContainer":"myProjects_gridContainer__J1NZq","projectCard":"myProjects_projectCard__TV9vx","myProjects":"myProjects_myProjects__QR5gg"};